export default __webpack_public_path__ + "static/media/IMG_7386.35e4dea8.jpg";